export default __webpack_public_path__ + "static/media/verified.066dea58.svg";